// src/components/AppHeader.js
import React from 'react';
import { CONNECTION_STATE } from '../hooks/useWebSocket';
import synapticsLogo from '../assets/logo_synaptics.png';
import adermLogo from '../assets/Aderm_Logo_Rond.png';

function Clock() {
  const [time, setTime] = React.useState('');
  React.useEffect(() => {
    const update = () => {
      setTime(new Date().toLocaleTimeString('fr-FR', { hour12: false }));
    };
    update();
    const t = setInterval(update, 1000);
    return () => clearInterval(t);
  }, []);
  return (
    <span style={{ fontFamily: 'var(--font-mono)', fontSize: 13, color: 'rgba(255,255,255,0.3)', letterSpacing: 2 }}>
      {time}
    </span>
  );
}

function WsStatusDot({ state }) {
  const map = {
    [CONNECTION_STATE.CONNECTED]:    { color: '#00e676', label: 'Connecté',    pulse: true  },
    [CONNECTION_STATE.CONNECTING]:   { color: '#f5a623', label: 'Connexion…',  pulse: true  },
    [CONNECTION_STATE.RECONNECTING]: { color: '#ff6b35', label: 'Reconnexion…',pulse: true  },
    [CONNECTION_STATE.DISCONNECTED]: { color: '#ff3d57', label: 'Déconnecté',  pulse: false },
  };
  const s = map[state] || map[CONNECTION_STATE.DISCONNECTED];

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
      <div style={{
        width: 7, height: 7, borderRadius: '50%',
        background: s.color,
        boxShadow: `0 0 6px ${s.color}`,
        animation: s.pulse ? 'pulse 1.5s infinite' : 'none',
      }}/>
      <span style={{ fontFamily: 'var(--font-sans)', fontSize: 10, letterSpacing: 2, textTransform: 'uppercase', color: s.color }}>
        {s.label}
      </span>
    </div>
  );
}

export default function AppHeader({ wsState }) {
  return (
    <header style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '8px 20px',
      background: 'linear-gradient(180deg, rgba(10,12,15,0.98) 0%, rgba(15,19,24,0.95) 100%)',
      borderBottom: '1px solid rgba(255,255,255,0.06)',
      flexShrink: 0,
      gap: 12,
      position: 'relative',
      zIndex: 10,
    }}>
      {/* Subtle top border gradient */}
      <div style={{
        position: 'absolute', top: 0, left: 0, right: 0, height: 2,
        background: 'linear-gradient(90deg, #f5a623, #29b6f6, #00e676, #f5a623)',
        backgroundSize: '200% 100%',
        animation: 'gradientShift 6s linear infinite',
      }}/>

      {/* LEFT: Synaptics */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, flex: '0 0 auto' }}>
        <img src={synapticsLogo} alt="Synaptics" style={{
          height: 56, width: 56, borderRadius: '50%',
          objectFit: 'cover', flexShrink: 0,
          border: '1px solid rgba(245,166,35,0.3)',
          boxShadow: '0 0 12px rgba(245,166,35,0.15)',
        }}/>
        <div style={{ borderLeft: '1px solid rgba(255,255,255,0.08)', paddingLeft: 12 }}>
          <div style={{
            fontFamily: 'var(--font-sans)', fontWeight: 700,
            fontSize: 12, letterSpacing: 2, textTransform: 'uppercase',
            color: '#f5a623', lineHeight: 1.4,
          }}>
            Synaptics Solutions &amp; Technologies sarl
          </div>
          <div style={{
            fontFamily: 'var(--font-sans)', fontSize: 10,
            color: 'rgba(255,255,255,0.3)', letterSpacing: 1, marginTop: 2,
          }}>
            Branche Amdjarass — Ennedi Est — Tchad
          </div>
        </div>
      </div>

      {/* CENTER */}
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4 }}>
        <div style={{
          fontFamily: 'var(--font-mono)', fontSize: 11,
          letterSpacing: 5, textTransform: 'uppercase',
          color: 'rgba(255,255,255,0.12)',
          borderTop: '1px solid rgba(255,255,255,0.06)',
          borderBottom: '1px solid rgba(255,255,255,0.06)',
          padding: '4px 20px',
        }}>
          Système de surveillance électrique
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
          <WsStatusDot state={wsState}/>
          <Clock/>
        </div>
      </div>

      {/* RIGHT: ADERM */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, flex: '0 0 auto' }}>
        <div style={{ borderRight: '1px solid rgba(255,255,255,0.08)', paddingRight: 12, textAlign: 'right' }}>
          <div style={{
            fontFamily: 'var(--font-sans)', fontWeight: 700,
            fontSize: 12, letterSpacing: 2, textTransform: 'uppercase',
            color: '#29b6f6', lineHeight: 1.4,
          }}>
            ADERM Tchad
          </div>
          <div style={{
            fontFamily: 'var(--font-sans)', fontSize: 10,
            color: 'rgba(255,255,255,0.3)', letterSpacing: 0.5, marginTop: 2, maxWidth: 260,
          }}>
            Agence pour le Développement de l'Électrification Rurale et la Maîtrise de l'Énergie
          </div>
        </div>
        <img src={adermLogo} alt="ADERM" style={{
          height: 56, width: 'auto',
          objectFit: 'contain', flexShrink: 0,
          filter: 'drop-shadow(0 0 8px rgba(41,182,246,0.2))',
        }}/>
      </div>
    </header>
  );
}
